module.exports = __webpack_public_path__ + "img/CLOSED.d40ff87e.svg";